"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _Instascan = require("kea-instascan");
exports.Instascan = _Instascan;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/qr/insta.js
// module id = 2248
// module chunks = 0